var Reports = {
    secondGroupBeingSelected: false,
    secondGroupInputs: [],

    init: function() {
        $('.datepicker').datepicker({
            format: 'dd/mm/yyyy',
            autoclose: true,
            weekStart: 1, // Start weeks on Monday,
        });

        Reports.bindNextButton();
        Reports.bindSingleSelect();
        Reports.bindGroupSelect();
        Reports.bindFrameworkCheckboxes();
        Reports.bindToggleArrows();
        Reports.bindGenerateButton();
        Reports.restoreState();
        Reports.bindReportTimeRadios();
        Reports.bindSinglePupilRadio();
        Reports.bindLevelsReportType();
        Reports.bindHideArchivedOnSingle();
        Reports.bindYearCheck();
        Reports.bindOverallRow();
        Reports.bindExcelOutput();
        Reports.bindBenchmarkCheck();
        Reports.bindPostDownloadToken();
        Reports.bindCheckLearningOutcomeSubjects();

        if (typeof report != 'undefined' && report == 'group-attainment') {
            Reports.bindSecondGroupContainer();
            Reports.bindSecondGroupDoneButton();
            Reports.bindSecondGroupButton();
        }
    },

    bindSecondGroupButton: function() {
        $('#secondGroupSelect').click(function() {
            Reports.secondGroupBeingSelected = true;
            $('#secondGroupDone').show();
            $('.first-group-check').prop('checked', false).addClass('first-group-highlighted');
        });
    },

    bindSecondGroupContainer: function() {
        $('.pupils-checkbox').click(function() {
            var checkBox = $(this);
            if ($('.pupils-checkbox:checked').length > 0) {
                $('#secondGroupContainer').show();
            } else {
                $('#secondGroupContainer').hide();
            }
            if (Reports.secondGroupBeingSelected) {
                var id = checkBox.attr('id');
                var cloneId = id + '-2';
                var name = checkBox.attr('name');
                var cloneName = name.replace('groups', 'groups_2');
                if (checkBox.is(':checked')) {
                    checkBox.addClass('second-group-check');
                    //Clone input;
                    var clone = checkBox.clone();
                    clone.attr('id', cloneId).attr('name', cloneName).prop('checked', true);
                    clone.addClass('hidden clone-check');
                    $('#reportForm').append(clone);
                } else {
                    checkBox.removeClass('second-group-check');
                    $('#' + cloneId).remove();
                }
            } else {
                if (checkBox.is(':checked')) {
                    checkBox.addClass('first-group-check');
                } else {
                    checkBox.removeClass('first-group-check');
                }
            }
        });
    },

    bindSecondGroupDoneButton: function() {
        $('#secondGroupDone').click(function() {
            Reports.secondGroupBeingSelected = false;
            var firstGroup = $('.first-group-check');
            $(this).hide();
            $('.second-group-check').not('.clone-check').prop('checked', false);
            firstGroup.prop('checked', true);
            firstGroup.removeClass('first-group-highlighted');
        });
    },

    processSecondGroupInputs: function() {

    },

    bindBenchmarkCheck: function() {
        $('.benchmark-framework').click(function() {
            $('#benchmarkCheckContainer').show();
        });
    },

    bindExcelOutput: function() {
        $('input[name="output"]').click(function() {
            var input = $(this);
            var pupilInfo = $('#pupilInfoRow');
            var toDecimal = $('#toDecimalRow');
            var toNumeric = $('#toNumericRow');
            if (input.val() == 'excel') {
                pupilInfo.slideDown('fast');
                toDecimal.slideDown('fast');
                toNumeric.slideDown('fast');
                return true;
            }
            pupilInfo.slideUp('fast');
            toDecimal.slideUp('fast');
            toNumeric.slideUp('fast');
        });
    },

    bindOverallRow: function() {
        $('.framework-show-subjects').on('change', function() {
            if ($('.p-scales:checked').length > 0 || $('.national-curriculum:checked').length > 0) {
                $('#overall-row').show();
                return true;
            }
            $('#overall-row').hide();
        });
    },

    bindHideArchivedOnSingle: function () {
        $('.single').on('click', function () {
            $('.archived-pupils').addClass('hidden');
        });
        $('.groups, .all').on('click', function () {
            $('.archived-pupils').removeClass('hidden');
        });
    },

    bindLevelsReportType: function() {
        $('.level-report-type').click(function() {
            $('.level-report-type-value').attr('disabled', true).hide();
            $('#' + $(this).val() + '-input').attr('disabled', false).show();
        });
    },

    bindYearCheck: function() {
        $('.year-check').click(function() {
            if (report == 'matrix' || report == 'group-attainment' || report == 'attainment-predictions' ||
                report == 'targets' || report == 'zones-matrix') {
                var box = $(this);
                if (box.is(":checked")) {
                    // the name of the box is retrieved using the .attr() method
                    // as it is assumed and expected to be immutable
                    var group = "input:checkbox[name='" + box.attr("name") + "']";
                    // the checked state of the group/box on the other hand will change
                    // and the current value is retrieved using .prop() method
                    $(group).prop("checked", false);
                    box.prop("checked", true);
                } else {
                    box.prop("checked", false);
                }
            }
        });
    },

    bindSingleSelect: function() {
        $('.pupil-report-search').select2({
            ajax: {
                url: '/admin/pupils/ajax',
                placeholder: 'Search by Last Name',
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        q: params.term,
                        page: params.page
                    };
                },
                results: function (data, page) {
                    return { results: data.results };
                },
            },
            minimumInputLength: 3
        });

        $('.custom-control-input').click(function() {
            if ($(this).attr('id') == 'radio-single') {
                $('#pupil-single').removeClass('hidden');
            } else {
                $('#pupil-single').addClass('hidden');
            }
        });
    },

    bindReportTimeRadios: function() {
        $('.report-time').click(function() {
            var dataBlock = $('#' + $(this).attr('id') + '-data');
            if ($(this).attr('id') == 'for-range') {
                /* disabled not returned in response - use hidden
                $('input[name="display_type"]').attr('disabled', true);
                */
                $('input[name="display_type"]').attr('hidden', true);
            } else {
                /* disabled not returned in response - use hidden
                $('input[name="display_type"]').removeAttr('disabled');
                */
                $('input[name="display_type"]').removeAttr('hidden');
            }
            $('.report-time-data').not(dataBlock).slideUp();
            dataBlock.slideDown();
        });
    },

    bindGroupSelect: function() {
        $('.custom-control-input').click(function() {
            if ($(this).attr('id') == 'radio-groups') {
                $('#pupil-groups').removeClass('hidden');
            } else {
                $('#pupil-groups').addClass('hidden');
            }
        });
    },

    bindFrameworkCheckboxes: function() {
        $('.framework-show-subjects').click(function () {
            Reports.toggleSubjectCheckboxes($(this));
        });

        $('.subject-check').click(function () {
            Reports.subjectSelect($(this));
        });
    },

    subjectSelect: function(sourceCheckBox) {
        var currentFrameworkId = $(sourceCheckBox).data('framework');
        var frameworkCheckbox = $('#framework-' + currentFrameworkId);
        var frameworkSubjectsChecked = $('.framework-' + currentFrameworkId + '-subject:checked').length > 0;
        frameworkCheckbox.prop('checked', frameworkSubjectsChecked).change();
        if (!$('#radio-single').is(':checked')) {
            $('.framework-show-subjects').not(frameworkCheckbox).prop('disabled', $(sourceCheckBox).prop('checked'));
            $('.subject-check:not([data-framework=' + currentFrameworkId + '])').prop('disabled', $(sourceCheckBox).prop('checked'));
        }
    },

    bindSinglePupilRadio: function() {
        $('.single-pupil').click(function() {
            $('.subject-check').prop('disabled', false);
            $('.framework-show-subjects').prop('disabled', false);
        });
    },

    toggleSubjectCheckboxes: function(sourceCheckBox) {
        var report = Reports.getReportName();
        var frameworkId = sourceCheckBox.val();
        var frameworkSubjects = $('#subjects-' + frameworkId);
        var subjectCheckBoxes = frameworkSubjects.find('.subject-check');

        /* add multiframework to matrix and zones-matrix
        if (report != 'achievement' && report != 'zones') {
        */
        if (report != 'achievement' && report != 'zones' && report != 'matrix' && report != 'zones-matrix') {
            if (!$('#radio-single').is(':checked')) {
                if (sourceCheckBox.is(':checked')) {
                    $('.framework-show-subjects').not(sourceCheckBox).prop('disabled', true);
                    $('.subject-check').not(subjectCheckBoxes).prop('disabled', true);
                } else {
                    $('.framework-show-subjects').not(sourceCheckBox).prop('disabled', false);
                    $('.subject-check').not(subjectCheckBoxes).prop('disabled', false);
                }
                $('.subject-check').prop('checked', false);
            }
        }
        frameworkSubjects.find('.subject-check').prop('checked', sourceCheckBox.prop("checked"));
    },

    bindToggleArrows: function() {
        $('.toggle-framework-subjects').click(function() {
            var frameworkId = $(this).data('framework');
            //var frameworkCheck =
            var frameworkSubjects = $('#subjects-' + frameworkId);

            if (frameworkSubjects.css('display') == 'none') {
                frameworkSubjects.slideDown();
                $(this).html('<i class="fa fa-chevron-up" aria-hidden="true"></i>');
            } else {
                frameworkSubjects.slideUp();
                $(this).html('<i class="fa fa-chevron-down" aria-hidden="true"></i>');
            }
        });
    },

    bindNextButton: function() {
        $('.reporting-next').on('click', function() {
            // if (($('.pupils-radio:checked').length <= 0) && !pupilSelected) {
            //     return alert('Please select one or more pupils before continuing.');
            // }

            if ($('input[type=radio]:checked').val() == 'single') {
                if ($('.pupil-report-search').val() == null) {
                    return alert('Please select one pupil before continuing.')
                }
            } else if ($('input[type=radio]:checked').val() == 'group') {
                if ($('#pupil-groups input[type=checkbox]:checked').length <= 0) {
                    return alert('Please select one or more groups of pupils before continuing.')
                }
            }
            if ($(this).attr('id') == 'subjects-next' && $(this).data('next') == 'options-accordion' &&
                !$("input[name='subject_ids[]']:checked").val() && !$("input[name='subject_ids[]']:checked").length) {
                return alert('Please select one or more subjects before continuing.')
            }

            if (typeof report != 'undefined' && report == 'incidents') {
                $('#focus').prop('checked', false);
            }

            $('#' + $(this).data('next')).click();
        });
    },

    restoreState: function() {
        if ($('.pupil-profile').length <= 0) {
            if (window.localStorage.getItem('selectedFrameworkCheckId')) {
                var checkbox = $('#' + window.localStorage.getItem('selectedFrameworkCheckId'));
                this.toggleSubjectCheckboxes(checkbox);
                window.localStorage.removeItem('selectedFrameworkCheckId');
            }
        }
    },

    bindGenerateButton: function() {
        var report = Reports.getReportName();
        if (report == 'daily-assessment') {
            return;
        }
        $('#generate-report').on('click', function(e) {
            if (!$('#radio-single').is(':checked')) {
                var checkedInput = $('.framework-show-subjects:checked')[0];
                window.localStorage.setItem('selectedFrameworkCheckId', $(checkedInput).attr('id'));
            }
            if ($('.pupils-radio:checked').length <= 0) {
                e.preventDefault();
                return alert('Please select one or more pupils before continuing.');
            }
            if ($("input[name='subject_ids[]']").length > 0 && !$("input[name='subject_ids[]']:checked").val() &&
                !$("input[name='subject_ids[]']:checked").length) {
                e.preventDefault();
                return alert('Please select one or more subjects before continuing.')
            }
            if ($('.pupils-radio:checked').val() == 'single') {
                if ($('.pupil-report-search').val() == null) {
                    e.preventDefault();
                    return alert('Please select one or more groups of pupils before continuing.')
                }
            } else if ($('.pupils-radio:checked').val() == 'group') {
                if ($('.pupils-checkbox:checked').length <= 0) {
                    e.preventDefault();
                    return alert('Please select one or more pupils before continuing.')
                }
            }
            if ($('#for-years-data').find('.for-years').length > 0) {
                if ($('.for-years input[type=checkbox]:checked').length <= 0) {
                    e.preventDefault();
                    return alert('Please select one or more years before continuing.')
                }
            }
            if ($('#for-range').is(':checked')) {
                var dateRangeInputs = $("input[name='range_dates[]']");
                var totalInputCount = dateRangeInputs.length;
                var filledInputCount = dateRangeInputs.filter(function() {
                    return $(this).val();
                }).length;
                if (filledInputCount < totalInputCount) {
                    e.preventDefault();
                    return alert('Please input a valid date range.');
                }
            }
        });
    },

    getReportName: function() {
        var url = window.location.pathname;
        var pieces = url.split('/');
        return pieces[2];
    },

    // the following four routines are the price paid for there being no download file event handler:
    // (1) create a random token
    // (2) post that token in the form
    // (3) set a timer going to look for a signal from the server that the file is being downloaded
    // (4) when the signal is receiver clear the process-wait overlay
    // (5) tidy up ready for next form submit
    //
    bindPostDownloadToken: function() {
        $('#generate-report').on('click', function(e) {
            if ($('input[name="output"]:checked').size() >0) {
                var radio = $('input[name="output"]:checked');
                if (radio.val() == 'excel' || radio.val() == 'pdf' || radio.val() == 'word') {
                    //alert (radio.val() + ' selected');
                    var downloadTimer;
                    //var attempts = 30;

                    var downloadToken = Reports.setFormToken();

                    downloadTimer = window.setInterval( function() {
                        var token = Reports.getCookie( "downloadToken" );

                        //alert('Created in JS '+downloadToken+' - echoed from PHP '+token);

                        //if( (token == downloadToken) || (attempts == 0) ) {
                        if(token == downloadToken) {
                            $('#wait-overlay').hide();
                            window.clearInterval( downloadTimer );
                            Reports.expireCookie( 'downloadToken' );
                            //attempts = 30;
                        }

                        //attempts--;
                    }, 1000 );
                }
            }
        });
    },

    setFormToken: function() {
        //var downloadToken = new Date().getTime();
        var token = new Date().getTime();
        //document.getElementById( 'downloadToken' ).value = downloadToken;
        $('<input type="hidden" />')
            .attr('id', 'downloadToken')
            .attr('name', 'downloadToken')
            .attr('value', token)
            .appendTo('#reportForm');

        return token;
    },

    getCookie: function(name) {
        /*
        var parts = document.cookie.split(name + '=');
        if (parts.length == 2) return parts.pop().split(';').shift();
        */
        // returns the cookie with the given name,
        // or undefined if not found
        var matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    },

    expireCookie: function(cName) {
        document.cookie =
            encodeURIComponent(cName) + '=deleted; expires=' + new Date( 0 ).toUTCString();
    },

    bindCheckLearningOutcomeSubjects: function() {
        $('#subject-all-check').on('click', function() {
            if ($(this).prop('checked')) {
                $('.learning-outcome-subject').each(function() {
                    $(this).prop("checked", true);
                });
            } else {
                $('.learning-outcome-subject').each(function() {
                    $(this).prop("checked", false);
                });
            }
        })
    },

};